// The browser tab while the form dialog is open.
//
// The dialog is client-side, so the tab still read the list page behind it -
// "Kunden · workly-intranet" with a customer open on top. Several tabs on
// different records were then indistinguishable, which is the thing the tab
// title exists to solve.
//
// The title is read out of the fragment that just arrived rather than passed
// in by the caller: every _form.pug opens with the same h1, so this works for
// every resource and a new one needs no wiring here.

// Whatever the tab said before the dialog opened. Restored on close, so the
// page behind it gets its own title back.
let vorherigerTitel = null;

// The h1 every _form.pug renders ("Kunde bearbeiten", "Job erstellen").
const UEBERSCHRIFT = 'h1.card-title';

// Fields worth putting in the tab, best first. A record's own name says far
// more than "Kunde bearbeiten" does when several tabs are open.
const NAME_FELDER = ['titel', 'name', 'firmenname', 'bezeichnung', 'nachname'];

function datensatzName(wurzel) {
  for (const feld of NAME_FELDER) {
    const wert = wurzel.querySelector(`[name="${feld}"]`)?.value?.trim();
    if (wert) return wert;
  }
  return '';
}

/**
 * Puts the open record in the tab title.
 *
 * @param {HTMLElement} wurzel  the dialog body holding the fragment
 */
export function setzeModalTitel(wurzel) {
  if (!wurzel) return;

  const ueberschrift = wurzel.querySelector(UEBERSCHRIFT)?.textContent?.trim();
  if (!ueberschrift) return;

  // Only on the first open. A save that reopens the dialog must not record the
  // dialog's own title as the one to go back to.
  if (vorherigerTitel === null) vorherigerTitel = document.title;

  const name = datensatzName(wurzel);
  const titel = name ? `${ueberschrift}: ${name}` : ueberschrift;

  document.title = `${titel} · workly-intranet`;
}

/**
 * Gives the page behind the dialog its title back.
 */
export function stelleTitelWiederHer() {
  if (vorherigerTitel === null) return;
  document.title = vorherigerTitel;
  vorherigerTitel = null;
}
